import { log } from '@intigral/utils';
import { PlayerEvent } from 'bitmovin-player';
import { useState } from 'react';

const useProgramRemainingTime = () => {
    const [currentProgramRemainingTime, setCurrentProgramRemainingTime] = useState(0);
    const [currentProgramDuration, setCurrentProgramDuration] = useState(0);

    const updateRemainingTime = (player: any, isPastProgram: boolean, selectedProgram: any) => {
        if (!player) return;

        if (player.on) {
            // TODO: Debounce or throttle if necessary
            player.on(PlayerEvent.TimeChanged, () => {
                let remainingTimeInMinutes = 0;

                if (player?.getCurrentTime) {
                    const currentPlayerTime = player?.getCurrentTime(); // seconds from stream start
                    const programStartTime = selectedProgram.startTime; // timestamp in ms
                    const programEndTime = selectedProgram.endTime; // timestamp in ms

                    // Guard against NaN or invalid values
                    if (!programStartTime || !programEndTime || !currentPlayerTime || isNaN(currentPlayerTime)) {
                        setCurrentProgramRemainingTime(0);
                        return;
                    }

                    // Calculate program duration in seconds for validation
                    const programDurationInSeconds = (programEndTime - programStartTime) / 1000;
                    const programDurationInMinutes = Math.floor(programDurationInSeconds / 60);

                    // Logic for past programs (if needed in future)
                    // if (isPastProgram) {
                    //     // Calculate remaining time by subtracting elapsed time from total duration
                    //     const remainingTimeInSeconds = programDurationInSeconds - currentPlayerTime;

                    //     // Convert to minutes and ensure it's not negative
                    //     const remainingTimeInMinutes = Math.max(0, Math.floor(remainingTimeInSeconds / 60));

                    //     setCurrentProgramRemainingTime(remainingTimeInMinutes);
                    //     setCurrentProgramDuration(programDurationInMinutes);
                    // } else {

                    if (!isPastProgram) {
                        // Calculate time elapsed since program start
                        const timeElapsedInSeconds = currentPlayerTime - programStartTime / 1000;

                        // Calculate remaining time by subtracting elapsed time from total duration
                        const remainingTimeInSeconds = programDurationInSeconds - timeElapsedInSeconds;

                        if (timeElapsedInSeconds < 0) {
                            remainingTimeInMinutes = 0;
                        } else {
                            // Convert to minutes and ensure it's not negative
                            remainingTimeInMinutes = Math.max(0, Math.floor(remainingTimeInSeconds / 60));
                        }

                        setCurrentProgramRemainingTime(remainingTimeInMinutes);
                        setCurrentProgramDuration(programDurationInMinutes);
                    }
                }
            });
        }
    };

    const resetRemainingTime = () => {
        setCurrentProgramRemainingTime(0);
    };

    return {
        currentProgramRemainingTime,
        currentProgramDuration,
        updateRemainingTime,
        resetRemainingTime,
    };
};

export default useProgramRemainingTime;
